import React from 'react';
import { InsidePagesCarousel } from '../InsidePagesCarousel';
import { SectionHeading } from './SectionHeading';
export function InsideSection() {
  return <section aria-labelledby="inside-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-20" data-id="element-114" data-mp="2lz7ysq8p4ia3">
      <div className="mx-auto max-w-6xl" data-id="element-115" data-mp="2h424p4553xax">
        <SectionHeading id="inside-heading" title="Take a Look Inside Your Teaching System" body="Explore real pages from the barbering technique library and see the teaching resources included in your system." data-id="element-116" data-mp="2d5mk16wj710o" />

        <div className="mt-12" data-id="element-117" data-mp="238q7mq3ihuqu">
          <InsidePagesCarousel data-id="element-118" data-mp="1y70wlagahh2r" />
        </div>

        <p className="mt-6 text-center font-body text-[13px] italic text-brand-charcoal/55" data-id="element-119" data-mp="1y7u80oq70ur8">
          Real pages from Volume 2 — tap any page to enlarge
        </p>
      </div>
    </section>;
}